export default __webpack_public_path__ + "static/media/14.55392a3c.jpg";